export const ADD_LOGIN_POLICY_DRAWER_TEST_ID = "add-login-policy-drawer";
